<template>
  <div class="box-func ">
    <div id="hrms17e-detail1">
      <template v-if="detail1Disp">
        <div class="panel-body">
          <div class="detail detail-responsive">
            <div class="container-fluid">
              <div class="row margin-b-5">
                <label class="col-sm-4 control-label align-right">{{ labels['HRAP32EC2']['10'] }}</label>
                <div class="col-sm-2">
                  <div class="form-control readonly-field-color">{{ setYearOutput(searchIndex.year) }}</div>
                </div>
                <label class="col-sm-1 control-label align-right">{{ labels['HRAP32EC2']['20'] }}</label>
                <div class="col-sm-1">
                  <div class="form-control readonly-field-color">{{ searchIndex.numtime }}</div>
                </div>
              </div>
              <div class="row">
                <label class="col-sm-4 control-label align-right">{{ labels['HRAP32EC2']['30'] }}</label>
                <div class="col-sm-4">
                  <hrms-lov v-model="codempid"
                            lovType="codempid"
                            :nowLang="nowLang"
                            name="codempid"
                            :disabled="eventBtn === 'edit'"
                            :descDisp="true"
                            :desc="descCodempid"
                            v-validate="'required'"
                            :has-error="errors.has('codempid')"  />
                  <div class="text-error" v-show="errors.has('codempid')">{{errors.first('codempid')}}</div>
                </div>
              </div>

              <div class="row margin-b-5">
                <label class="col-sm-4 control-label align-right">{{ labels['HRAP32EC2']['40'] }}</label>
                <div class="col-sm-4">
                  <div class="form-control readonly-field-color">{{ codcomp }} - {{ desc_codcomp }}</div>
                </div>
              </div>
              <div class="row margin-b-5">
                <label class="col-sm-4 control-label align-right">{{ labels['HRAP32EC2']['50'] }}</label>
                <div class="col-sm-4">
                  <div class="form-control readonly-field-color">{{ codpos }} - {{ desc_codpos }}</div>
                </div>
              </div>
            </div>

            <hrms-table :columns="detail1Table"
                        :data="detail1"
                        :detail1Selected="detail1Selected"
                        :addEvent="addEvent"
                        :editEvent="editEvent"
                        :deleteInlineEventBool="true"
                        :deleteInlineBtnDisp="false"
                        :saveInlineEvent="deleteEvent"
                        :nowLang="nowLang" />

          </div>
        </div>

        <div class="box-footer">
          <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-reply"></i>{{ labelsButton['back'] }}</button>
        </div>
      </template>

      <template v-else="detail2Disp">
        <detail2  :dataHeader="dataHeader"
                  :labels="labels"
                  :labelsButton="labelsButton"
                  :maxRowspan="maxRowspan"
                  :detail="detail2"
                  :nowLang="nowLang"
                  :toggle="toggle"
                  :inlineDetail2Tab1="inlineDetail2Tab1"
                  :inlineDetail2Tab2="inlineDetail2Tab2"
                  :detail2Tab1Table="detail2Tab1Table"
                  :detail2Tab2Table="detail2Tab2Table"
                  :indexSelected="indexSelected"
                  :searchIndex="searchIndex"
                  :detail1Selected="detail1Selected"
                  :setInlineDetail2Tab1="setInlineDetail2Tab1"
                  :setInlineDetail2Tab2="setInlineDetail2Tab2"
                  :postDetail2Save="postDetail2Save"
                  :dropdowns="dropdowns" />

      </template>

    </div>
  </div>
</template>

<script>
import detail2 from 'components/hrms17e/detail2'
import assetsUtils from 'assets/js/utils'

export default {
  name: 'hrms17e-detail1',
  props: [ 'labels',
    'labelsButton',
    'detail1',
    'detail2',
    'descCodempid',
    'eventBtn',
    'indexSelected',
    'searchIndex',
    'detail1Selected',
    'setDetail1Selected',
    'detail1Table',
    'toggle',
    'receivedHrms17eDetail2Create',
    'receivedHrms17eDetail2',
    'receivedHrms17eCodempid',
    'receivedHrms17eDetail',
    'postHrms17eDetail1TableDelete',
    'codempidQuery',
    'nowLang',
    'maxRowspan',
    'inlineDetail2Tab1',
    'inlineDetail2Tab2',
    'detail2Tab1Table',
    'detail2Tab2Table',
    'setInlineDetail2Tab1',
    'setInlineDetail2Tab2',
    'postDetail2Save',
    'detail1Disp',
    'detail2Disp',
    'setDetail1Disp',
    'setDetail2Disp',
    'dropdowns'
  ],
  data () {
    return {
      codempid: this.indexSelected.codempid,
      codcomp: this.indexSelected.codcomp,
      desc_codcomp: this.indexSelected.desc_codcomp,
      codpos: this.indexSelected.codpos,
      desc_codpos: this.indexSelected.desc_codpos,
      dataHeader: {}
    }
  },
  watch: {
    codempid (newVal) {
      this.receivedHrms17eCodempid(newVal)
      let editParams = {
        p_dteyreap: this.searchIndex.year,
        p_numtime: this.searchIndex.numtime,
        p_codempid_query: this.codempid
      }
      this.receivedHrms17eDetail(editParams)
    },
    indexSelected (newVal) {
      this.desc_codempid = newVal.desc_codempid
      this.codempid = newVal.codempid
      this.codcomp = newVal.codcomp
      this.desc_codcomp = newVal.desc_codcomp
      this.codpos = newVal.codpos
      this.desc_codpos = newVal.desc_codpos
    },
    codempidQuery (newVal) {
      this.desc_codempid = newVal.desc_codempid
      this.codcomp = newVal.codcomp
      this.desc_codcomp = newVal.desc_codcomp
      this.codpos = newVal.codpos
      this.desc_codpos = newVal.desc_codpos
    }
  },
  methods: {
    setYearOutput (date) {
      return assetsUtils.getYearOutput(date)
    },
    pageDetail (event, param) {
      switch (event) {
        case 'add':
          this.$validator.validateAll().then(result => {
            if (result) {
              let addParams = {
                p_codempid_query: this.codempid,
                p_dteyreap: this.searchIndex.year,
                p_numtime: this.searchIndex.numtime
              }
              this.dataHeader = {
                codempid: this.codempid,
                desc_codempid: this.codempidQuery.desc_codempid,
                codcomp: this.codempidQuery.codcomp,
                desc_codcomp: this.codempidQuery.desc_codcomp,
                codpos: this.codempidQuery.codpos,
                desc_codpos: this.codempidQuery.desc_codpos
              }
              this.receivedHrms17eDetail2Create(addParams)
              this.toggle('detail2')
            }
          })
          break
        case 'edit':
          let editParams = {
            p_codempid_query: this.codempid,
            p_dteyreap: this.searchIndex.year,
            p_numtime: this.searchIndex.numtime,
            p_kpino: param.kpino
          }
          this.dataHeader = this.indexSelected
          if (this.eventBtn === 'add') {
            this.dataHeader = {
              codempid: this.codempid,
              desc_codempid: this.codempidQuery.desc_codempid,
              codcomp: this.codempidQuery.codcomp,
              desc_codcomp: this.codempidQuery.desc_codcomp,
              codpos: this.codempidQuery.codpos,
              desc_codpos: this.codempidQuery.desc_codpos
            }
          }
          this.receivedHrms17eDetail2(editParams)
          this.toggle('detail2')
          break
        default:
          break
      }
    },
    addEvent (param) {
      this.pageDetail('add')
    },
    editEvent (param) {
      this.setDetail1Selected(param)
      this.pageDetail('edit', param)
    },
    deleteEvent (dataRowsHasFlg) {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.postHrms17eDetail1TableDelete({ searchIndex: this.searchIndex, indexSelected: this.indexSelected, dataRowsHasFlg: dataRowsHasFlg })
        }
      })
    }
  },
  components: {
    detail2
  }
}
</script>



// WEBPACK FOOTER //
// detail1.vue?cb7cdac6